import * as React from 'react';
import Select, { components, InputProps } from 'react-select';
import { orderBy, map } from "lodash";
import { ServiceObjectAddressLayout } from '../../../models/ServiceObjectModels';
import { ServiceObjectTypeNumber } from '../../../models/SettingModels'
import { NotificationTypeEnum, NotificationToast } from '../../../models/NotificationModels'
import { ToastNotificationManager } from '../../../infrastructure/ToastNotificationManager'
import { ApiResponseHelper } from '../../../infrastructure/utils/ApiResponseHelper'
import { ServiceObjectRequests } from '../../../apiRequests/ServiceObjectRequests';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
interface ServiceObjectSearchProps {
    serviceObject: ServiceObjectAddressLayout | null,
    isValid?: boolean,
    serviceObjectTypeNumber?: ServiceObjectTypeNumber,
    SetServiceObject(serviceObject: ServiceObjectAddressLayout | null): void,
}

interface ServiceObjectSearchState {
    isOpenMenu: boolean;
    isSearch: boolean;
    inputValue: string;
    selectServiceObject: ServiceObjectAddressLayout | null;
    serviceObjects: ServiceObjectAddressLayout[];
}



export default class ServiceObjectSearch extends React.PureComponent<ServiceObjectSearchProps, ServiceObjectSearchState> {

    private apiServiceObjectRequest: ServiceObjectRequests;

    constructor(props: ServiceObjectSearchProps) {
        super(props)
        this.state = {
            isOpenMenu: false,
            isSearch: false,
            inputValue: "",
            selectServiceObject: null,
            serviceObjects: []
        }
        this.CloseMenu = this.CloseMenu.bind(this);
        this.OpenMenu = this.OpenMenu.bind(this);
        this.OnChangeValue = this.OnChangeValue.bind(this);
        this.OnParentServiceObject = this.OnParentServiceObject.bind(this);
        this.GetParentServiceObject = this.GetParentServiceObject.bind(this);
        this.GetServiceObjects = this.GetServiceObjects.bind(this);

        this.apiServiceObjectRequest = new ServiceObjectRequests();

    }

    async componentDidMount() {
        this.apiServiceObjectRequest.Init();
        if (this.props.serviceObject) {
            this.setState({
                isSearch: true,
                serviceObjects: []
            })
            var result = await this.GetServiceObjects(this.props.serviceObject.serviceObjectId);
            this.setState({
                serviceObjects: result,
                isSearch: false,
                selectServiceObject: this.props.serviceObject,
                isOpenMenu: false,
            })
        }
        else {
            this.setState({
                isSearch: true,
                serviceObjects: []
            })
            var result = await this.GetServiceObjects(null);
            this.setState({
                serviceObjects: result,
                isSearch: false,
                isOpenMenu: false,

            })
        }
    }




    componentWillUnmount() {
        this.apiServiceObjectRequest.Abort();
    }



    private CloseMenu(): void {
        this.setState({ isOpenMenu: false })
    }

    private OpenMenu(): void {
        this.setState({ isOpenMenu: true })
    }

    public async GetServiceObjects(parentId: number | null): Promise<ServiceObjectAddressLayout[]> {

        var resultGetServiceObjects = await this.apiServiceObjectRequest.GetServiceObjects(parentId)
        if (resultGetServiceObjects.result) {
            return orderBy(map(resultGetServiceObjects.data, item => ({ ...item, sortKey1: this.props.serviceObjectTypeNumber?.types?.some(x => x === item.serviceObjectType) ? parseInt(item.serviceObjectShortName || '0') : item.serviceObjectShortName })), ["sortKey1"], ['asc', 'asc']);

        }
        else {
            let notificationError: NotificationToast = {
                type: NotificationTypeEnum.danger,
                message: `Ошибка получения адресов. ${ApiResponseHelper.GetErrorMessage(resultGetServiceObjects.error)}`,
                additionalMessage: ApiResponseHelper.GetErrorGuid(resultGetServiceObjects.error)
            }
            ToastNotificationManager.SendToast(notificationError);
            return [];

        }
    }



    public async GetParentServiceObject(parentServiceObjectId: number): Promise<ServiceObjectAddressLayout | null> {
        var resultGetServiceObject = await this.apiServiceObjectRequest.GetServiceObject(parentServiceObjectId)
        if (resultGetServiceObject.result && resultGetServiceObject.data) {
            return resultGetServiceObject.data;
        }
        else {
            if (!resultGetServiceObject.result) {
                let notificationError: NotificationToast = {
                    type: NotificationTypeEnum.danger,
                    message: `Ошибка получения адресов. ${ApiResponseHelper.GetErrorMessage(resultGetServiceObject.error)}`,
                    additionalMessage: ApiResponseHelper.GetErrorGuid(resultGetServiceObject.error)
                }
                ToastNotificationManager.SendToast(notificationError);

            }
            return null;

        }
    }

    public async OnChangeValue(serviceObject: ServiceObjectAddressLayout | null) {

        this.setState({
            isSearch: true,
            selectServiceObject: serviceObject,
            serviceObjects: []
        })
        var result = await this.GetServiceObjects(serviceObject?.serviceObjectId || null)

        this.setState({
            serviceObjects: result,
            isSearch: false,
            isOpenMenu: true
        })
        if (result.length === 0) this.CloseMenu();
        this.props.SetServiceObject(serviceObject);

    }

    public async OnParentServiceObject() {
        if (this.state.selectServiceObject?.parentServiceObjectId) {
            let parent = await this.GetParentServiceObject(this.state.selectServiceObject.parentServiceObjectId)
            await this.OnChangeValue(parent)
        }
        else {
            await this.OnChangeValue(null)

        }

    }

    render() {
        let inputLeft = 0;
        let carriage = document.getElementById("carriage");
        if (carriage !== null) {
            inputLeft = carriage.offsetLeft
        }


        return (
            <React.Fragment>
                <div className='address-input-wrapper'>
                    <div className='address-input-placeholder address-selector-placeholder' style={{ top: this.state.inputValue !== "" || this.state.selectServiceObject !== null ? "" : "24px" }}> Адрес</div>
                    <Select id={"address-selector"}
                        components={{
                            MultiValueContainer: (props) =>
                                <div className="address-selector">
                                    <span>{props.data.serviceObjectName} </span>
                                    &nbsp;
                                    <span style={{ visibility: "hidden" }} id="carriage"></span>
                                </div>,
                            DropdownIndicator: (props) => <React.Fragment />,
                            IndicatorSeparator: (props) => <React.Fragment />,
                            Placeholder: (props) => <React.Fragment />,
                            /* Input: (props: InputProps<ServiceObjectAddressLayout, true>) => {
                                 if (props.isHidden) {
                                   return <components.Input {...props} />;
                                 }
                                 return (
                                       <components.Input {...props}  inputClassName="Test"/>
                                );}*/
                        }}
                        isMulti
                        onBlur={this.CloseMenu}
                        onFocus={() => this.state.serviceObjects.length === 0 ? this.CloseMenu() : this.OpenMenu()}
                        menuShouldBlockScroll={false}
                        // menuPosition={'fixed'}
                        placeholder=""
                        isClearable={true}
                        loadingMessage={e => "Поиск..."}
                        noOptionsMessage={e => ""}
                        menuIsOpen={this.state.isOpenMenu}
                        blurInputOnSelect={false}
                        isLoading={this.state.isSearch}
                        styles={{
                            container: (provided) => ({
                                ...provided,
                                minHeight: '1px',
                                width: "100%",
                            }),
                            control: (provided, props) => ({
                                ...provided,
                                transition: "0.2s",
                                color: "rgba(44, 59, 72)",
                                background: "#F8F8F8",
                                borderRadius: "0.5rem",
                                minHeight: "4rem",
                                padding: "0 1rem",

                                boxShadow: "none",
                                border: "1px solid transparent",
                                "&:hover": { border: "1px solid transparent", },
                            }),

                            menu: (provided) => ({
                                ...provided,
                                transition: "0.1s",
                                background: "#F8F8F8",
                            }),
                            option: (provided, props) => ({
                                ...provided,
                                "&:hover": { background: "#d5d8da" },

                                borderBottom: "0.1rem solid #d5d8da",
                                background: props.isSelected ? "#d5d8da" : "none",
                                color: "rgba(44, 59, 72)"

                            }),
                            input: (provided, props) => ({
                                ...provided,
                                color: "rgba(44, 59, 72)",
                                maxWidth: "1rem",
                                margin: "0",
                                paddingLeft: "0",

                                minHeight: "min-content",
                                paddingBottom: "0",
                                left: inputLeft,
                                paddingTop: this.state.inputValue === "" ? "0px !important" : ""

                            }),
                            indicatorsContainer: (provided, props) => ({
                                ...provided,
                                minWidth: "40px"

                            }),
                            valueContainer: (provided, props) => ({
                                ...provided,
                                alignItems: "end",

                            }),
                            multiValue: (provided, props) => ({
                                ...provided,
                                marginRight: "1rem",

                            }),
                        }}

                        value={this.state.selectServiceObject ? this.state.selectServiceObject : []}
                        getOptionLabel={option => option.serviceObjectName || '--'}
                        getOptionValue={option => option.serviceObjectId.toString()}
                        filterOption={(option, string) => {
                            let serviceObeject = option.data as ServiceObjectAddressLayout;
                            if (serviceObeject) {
                                return serviceObeject.serviceObjectShortName?.toLowerCase()?.includes(string?.toLowerCase()) === true
                            }
                            else {
                                return false;
                            }
                        }}
                        onInputChange={(e) => this.setState({ inputValue: e })}
                        onChange={async (value, action) => {
                            if (Array.isArray(value) &&
                                !this.state.isSearch) {
                                let serviceObject = value[value.length - 1] as ServiceObjectAddressLayout;
                                if (serviceObject) {
                                    await this.OnChangeValue(serviceObject);
                                }
                                else if (!serviceObject &&
                                    action.action === "clear") {
                                    await this.OnChangeValue(null);
                                }
                                else {
                                    await this.OnParentServiceObject();
                                }
                            }
                        }}
                        options={this.state.serviceObjects}
                    />
                </div>
            </React.Fragment>
        )
    }
}